<mat-form-field
  class="tags-autocomplete"
  subscriptSizing="dynamic"
  [appearance]="options.appearance"
  (click)="onMatFormFieldClick($event)"
  [class.mat-form-field-invalid]="isError"
  [class.disabled]="config.disabled"
>
  <mat-label>{{ options.label }}</mat-label>
  <mat-chip-grid #chipList aria-label=" Tags selection">
    @for (tag of selectedTags$ | async; track tag) {
    <mat-chip-row
      [selectable]="options.selectable"
      [removable]="options.removable"
      [class.highlight]="tag.highlight"
      (removed)="remove(tag.id)"
    >
      {{ tag.name }}
      @if (options.removable) {
      <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip-row>
    }
    <input
      [placeholder]="getPlaceholder()"
      #tagInput
      [formControl]="tagCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
      #trigger="matAutocompleteTrigger"
      [ngClass]="{ error: isError }"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @if ((filteredTags | async)?.length < 3 && tagCtrl.value && options.addTag) {
    <mat-option [value]="tagCtrl.value" class="custom-option">
      <span class="new-tag-prefix">{{ options.addTagText + ': ' }}</span
      ><span class="new-tag">{{ tagCtrl.value }}</span>
    </mat-option>
    } @for (tag of filteredTags | async; track tag; let i = $index) { @if (tag.isCategory) {
    <mat-option class="category-header" [disabled]="true">
      <strong>{{ tag.name }}</strong>
    </mat-option>
    } @if (!tag.isCategory) {
    <mat-option [value]="tag.id">
      <div class="d-flex align-items-center">
        <mat-icon>{{
          isTagSelected(tag.name) ? 'check_box' : 'check_box_outline_blank'
        }}</mat-icon>
        <span>{{ tag.name }}</span>
      </div>
    </mat-option>
    } }
  </mat-autocomplete>
  <mat-icon matSuffix>arrow_drop_down</mat-icon>
</mat-form-field>
@if (isError) {
<mat-error class="error-message">
  {{ errorMessage }}
</mat-error>
}
